import { sp, RenderListDataOptions } from "@pnp/sp";

import { cleanPrice, getWines, getSlots } from "./utils";
import { configuration } from "./config";

const fakeGetExperience = () =>
  new Promise(resolve =>
    setTimeout(
      resolve(
        {
          id: 2,
          title: "I vini di Monterufoli",
          description:
            "Visita alla cantina degustazione guidata di tutti i vini della tenuta in abbinamento a salumi e formaggi di produttori locali.",
          duration: "90''",
          glasses: "6 calici",
          price: 90,
          wines: ["Pian di Seta", "Vermentino di toscana", "Poggio Miniera"],
          morningSlotStart: [9, 0],
          morningSlotEnd: [11, 15],
          afternoonSlotStart: [13, 0],
          afternoonSlotEnd: [21, 30]
        },
        500
      )
    )
  );

const remoteGetExperience = () =>
  sp.web.lists
    .getByTitle(window["_spPageContextInfo"].listTitle)
    .renderListDataAsStream({
      RenderOptions: RenderListDataOptions.ListData,
      ViewXml: String.format(
        configuration.experience.query,
        window["_spPageContextInfo"].pageItemId
      )
    })
    .then(data => {
      try {
        const exp = data.Row[0];
        const rv = {
          id: exp.UniqueId,
          title: exp.Title,
          description: exp.DescrizioneBreve,
          duration: exp.Durata ? `${parseInt(exp.Durata)}'` : "",
          glasses: exp.Calici,
          price: cleanPrice(exp.Prezzo) || 0,
          wines: getWines(exp.ViniSelezionati),
          morningSlotStart: getSlots(exp.InizioMattina) || [9, 0],
          morningSlotEnd: getSlots(exp.FineMattina) || [13, 0],
          afternoonSlotStart: getSlots(exp.InizioPomeriggio) || [14, 0],
          afternoonSlotEnd: getSlots(exp.FinePomeriggio) || [18, 0]
        };
        return rv;
      } catch (e) {
        console.error(e);
        throw e;
      }
    });

export const getExperience = configuration.fakeData
  ? fakeGetExperience
  : remoteGetExperience;
